import { defineComponent as _defineComponent } from 'vue'
import { formatNumber } from '~/assets/helper/functions'
import { type MetricValueType } from '~/types/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'FormattedMetricValue',
  props: {
  valueType: { type: String },
  valueKey: { type: String, default: () => 'actual' },
  value: { type: Object as () => MetricValueType },
  showEditPlaceholder: { type: Boolean, default: true },
},
  setup(__props) {



return { __sfc: true,formatNumber }
}

})